<div class="schedule-container">
  <!-- Title Section -->
  <div class="title-section">
    <h3 class="section-title">Schedule</h3>
    <button class="edit-btn" (click)="onEditClick()">
      <span>Edit</span>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99935 4.33321L11.666 6.99988M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z" stroke="#1B5BFF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
        
    </button>
  </div>

  <!-- Schedule Form -->
  <div class="schedule-form">
    <div class="form-row">
      <div class="form-group">
        <label class="form-label">START DATE</label>
        <div *ngIf="!isEditMode" class="form-value">{{ scheduleData.startDate || 'Not set' }}</div>
        <input *ngIf="isEditMode" type="date" class="form-input" [(ngModel)]="scheduleData.startDate">
      </div>
      <div class="form-group">
        <label class="form-label">START TIME</label>
        <div *ngIf="!isEditMode" class="form-value">{{ scheduleData.startTime || 'Not set' }}</div>
        <input *ngIf="isEditMode" type="time" class="form-input" [(ngModel)]="scheduleData.startTime">
      </div>
    </div>
    
    <div class="form-row">
      <div class="form-group">
        <label class="form-label">END DATE</label>
        <div *ngIf="!isEditMode" class="form-value">{{ scheduleData.endDate || 'Not set' }}</div>
        <input *ngIf="isEditMode" type="date" class="form-input" [(ngModel)]="scheduleData.endDate">
      </div>
      <div class="form-group">
        <label class="form-label">END TIME</label>
        <div *ngIf="!isEditMode" class="form-value">{{ scheduleData.endTime || 'Not set' }}</div>
        <input *ngIf="isEditMode" type="time" class="form-input" [(ngModel)]="scheduleData.endTime">
      </div>
    </div>
    
    <div class="form-row">
      <div class="form-group">
        <label class="form-label">RECURRING FREQUENCY</label>
        <div *ngIf="!isEditMode" class="form-value">{{ removeUnderscores(scheduleData.recurringFrequency) }}</div>
        <select *ngIf="isEditMode" class="form-input" [(ngModel)]="scheduleData.recurringFrequency">
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
          <option value="Yearly">Yearly</option>
        </select>
      </div>
    </div>
  </div>
</div>
